import { m2mAuthTokenApi } from "./client";
import { parseJwtPayload } from "./jwt";
import {
  defaultStorageAdapter,
  PersistenceStorageAdapter,
} from "./persistenceDatabase";
import { requestGetToken } from "./api/getToken";

export const createRefreshAuth =
  (storage: PersistenceStorageAdapter = defaultStorageAdapter) =>
  async () => {
    const auth = await storage.get();
    if (!auth) return null;

    const payload = parseJwtPayload(auth.accessToken);
    if (!payload) {
      return null;
    }

    const { data: newAuth } = await requestGetToken({
      refreshToken: auth.refreshToken.refreshToken,
      userId: payload.userId,
    });

    if (newAuth) {
      const authToken = newAuth.accessToken;
      await m2mAuthTokenApi.set(authToken);
      await storage.set(newAuth);
      return authToken;
    }
    return null;
  };
